import { axiosInstance, parseResult } from "./CommonApi";

//사용자 현황
export const getUserList = async () => {
  const response = await axiosInstance.get(`/accounts/user/list`);
  return parseResult(response);
};
// 사용자 생성
export const createUser = async (userData) => {
  const formData = new FormData();
  // 파일 분리
  const { ciLogo, ...payload } = userData;
  // payload를 JSON 문자열로 추가
  formData.append("payload", JSON.stringify(payload));
  // 파일이 있으면 추가
  if (ciLogo) {
    formData.append("ciLogo", ciLogo);
  }
  const response = await axiosInstance.post(
    `/accounts/user/create/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return parseResult(response);
};
// 여러 사용자 삭제
export const deleteUsers = async (userIds) => {
  const response = await axiosInstance.delete(`/accounts/user/delete/`, {
    data: { userIds },
  });
  return parseResult(response);
};

// 사용자 정보 수정
export const updateUser = async (userData) => {
  const formData = new FormData();
  const { ciLogo, ...payload } = userData;
  formData.append("payload", JSON.stringify(payload));
  if (ciLogo) {
    formData.append("ciLogo", ciLogo);
  }
  const response = await axiosInstance.post(
    `/accounts/user/update/`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return parseResult(response);
};
